export const Data = [
  {
    id: 11,
    title: "T-thocky KeyBoard",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    img :'https://vibegaming.com.bd/wp-content/uploads/2022/07/1-1.png',
    amount:1,
    price: 450,
    category: "keyboard",
    rating: 5
  },
  {
    id: 12,
    title: "Rk 65",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.",
    img :'https://vibegaming.com.bd/wp-content/uploads/2024/03/Untitled-design-44.png',
    amount:1,
    price: 55,
    category: "keyboard",
    rating: 5
  },
  {
    id: 13,
    title: "AulaF75",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.",
    img :'https://vibegaming.com.bd/wp-content/uploads/2023/12/03bca74204c5c7cb02db780221243957.webp',
    amount:1,
    price: 450,

    category: "keyboard",
    rating: 5
  },
  {
    id: 14,
    title: "Mir zifriend",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.",
    img: "https://vibegaming.com.bd/wp-content/uploads/2024/02/Untitled-design-27.png",
    amount:1,
    price: 450,

    category: "keyboard",
    rating: 5
  }, {
    id: 21,
    title: "ATTACK SHARK X3 Lightweight Wireless Gaming Mouse Tri-Mode    ",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.
    `,
    price: 450,
    img: "https://vibegaming.com.bd/wp-content/uploads/2023/10/61WZnwT6lL._AC_SX466_.webp",
    amount:1,
    category: "mouse",
    rating: 5
  },
  {
    id: 22,
    title: "GL Model D Wireless Gaming Mouse    ",
    desc: `ATTACK SHARK X3 Lightweight Wireless Gaming Mouse, the ultimate choice for gamers. With versatile Tri-Mode connectivity (2.4G/USB-C Wired/Bluetooth), experience seamless gaming on PC, Laptop, Win, or Mac systems. 
    Boasting an impressive 26K DPI and powered by the PAW3395 Optical Sensor and Kailh GM8.0 Switch, this mouse delivers unparalleled precision and responsiveness.
    `,
    price: 799,
    img: "https://vibegaming.com.bd/wp-content/uploads/2022/05/D-wireless-Black.png",
    amount:1,
    category: "mouse",
    rating: 5
  },
  {
    id: 17,
    title: "GL Model O Wireless Gaming Mouse",
    desc: `makes you feel every moment of your workflow with 
             even more precision, tactility, and performance, thanks to Quiet Clicks and an 8,000 DPI track-on-glass 4 mm minimum glass thickness.`,
    price: 555,
    img: "https://vibegaming.com.bd/wp-content/uploads/2022/10/web-1.png",
    amount:1,
    category: "mouse",
    rating: 5
  },
  {
    id: 18,
    title: "Logitech MX Master 3S Wireless",
    desc: `Glorious Model O Gaming Mouse | Wireless is impossibly lightweight, ambidextrous gaming mouse with lag-free connectivity and lightning-fast
     performance with our BAMF wireless sensor. Vibe Gaming is the exclusive distributor of Glorious products in Bangladesh.
    `,
    price: 350 ,
    img: "https://vibegaming.com.bd/wp-content/uploads/2022/05/1_white_matte_527055da-9b41-48ed-b1de-afd49b3fb5f4_1000x-4.webp",
    amount:1,
    category: "mouse",
    rating: 5
  },
  {
    id: 19,
    title: "Fantech Venom II WGC2 Space Edition Wireless Gaming Mouse",
    desc: `Fantech Venom II WGC2 Space Edition Wireless Gaming Mouse has connectivity: wireless, sensor type: optical, sensor: PixArt PAW3212 and adjustable LOD: no. Get free shipping on orders over 2500 BDT from Vibe Gaming
    `,
    price: 175,
    img: "https://vibegaming.com.bd/wp-content/uploads/2023/12/WGC2_white_icon_758455p.png.png",
    amount:1,
    category: "mouse",
    rating: 5
  },
  {
    id: 16,
    title: "Dell Some MOdel",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 10,
    img: "https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg",
    amount:1,
    category: "laptop",
    rating: 5
  } , // Monitors
  {
    id: 31,
    title: "Samsung 32-inch UJ59 4K Gaming Monitor",
    desc: `"ULorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 379,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 32,
    title: "Dell Ultrasharp U2718Q 27-Inch 4K Monitor",
    desc: `"ULorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 799,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 33,
    title: "LG 27GN950-B 27 Inch UHD Nano IPS Display Ultragear Gaming Monitor",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1296,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 34,
    title: "Acer Predator XB273K Gpbmiipprzx 27-Inch UHD Gaming Monitor",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 699,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 35,
    title: "ASUS ROG Swift PG279Q 27-Inch Gaming Monitor",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 699,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 36,
    title: "BenQ EW3280U 32 inch 4K Monitor",
    desc: `"EntertLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 799,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 37,
    title: "ViewSonic VX2458-C-MHD 24 Inch 1080p Curved Monitor",
    desc: `"CurvedLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 169,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 38,
    title: "HP VH240a 23.8 Inch Monitor",
    desc: `"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 15,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 39,
    title: "Sceptre E248W-19203R 24 Inch Monitor",
    desc: `"UltLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 159,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
  {
    id: 40,
    title: "AOC CQ27G2 27 Super Curved Frameless Gaming Monitor",
    desc: `"CurvedLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 409,
    img: "https://www.startech.com.bd/image/cache/catalog/monitor/value-top/t22vf/t22vf-001-500x500.webp",
    amount: 1,
    category: "monitor",
    rating: 5
  },
   // Laptops
   {
    id: 41,
    title: "Apple MacBook Pro 16-Inch",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 2399,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 42,
    title: "Dell XPS 15",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 2099,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 43,
    title: "HP Spectre x360",
    desc: `"ConLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1299,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 44,
    title: "Asus ROG Zephyrus G14",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1499,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 45,
    title: "Lenovo ThinkPad X1 Carbon",
    desc: `"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1699,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 46,
    title: "Microsoft Surface Laptop 4",
    desc: `"TouLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1299,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },
  {
    id: 47,
    title: "Razer Blade 15",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus nec ligula ac justo commodo sodales. Sed sit amet aliquet ex, et eleifend justo.`,
    price: 1699,
    img :'https://m.media-amazon.com/images/I/71fPuKH1r5L._AC_UY218_.jpg',
    amount: 1,
    category: "laptop",
    rating: 5
  },

    
];

